//Specific JS for this skin
require(['jquery'], function ($) {
    //$('#mini-cart .hide-below-960').html("<i class='fa fa-shopping-cart'></i>");
    $('#mini-cart .hide-below-960').html(function() {
    return "<i class='fa fa-shopping-cart'></i>"+$(this).html();
  });
    $('.form-search .button-search').html("<i class='fa fa-search'></i>");
});
